import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginAPIs } from "../../../../API/LoginAPIs/LoginAPIs";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import './AdminLogin.css'
import ApiResponseHandler from "../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import AdminDashboard from "../AdminDashboard/AdminDashboard";


export default function AdminLogin(){

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [sending, setSending] = useState(false);
    const [invalid, setInvalid] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');

    const [showDash, setShowDash] = useState(false);

    const handleSubmit = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setSending(true);
        setInvalid(false);
        setErrorMsg('');
        const postJSON = {
        username: userId,
        password: password,
        }
        LoginAPIs.PostLogin(postJSON)
        .then((response) => {
            if(response.status === 200){
                console.log(response);
                if(!response.data.error){
                    if(response.data.role === 'administrator'){
                        setShowDash(true);
                    }
                    else{
                        setInvalid(true);
                        setErrorMsg('Incorrect login details');
                    }
                    
                }
                else{
                    setInvalid(true);
                    setErrorMsg('Incorrect login details');
                }
            }
            setSending(false)
           })
           .catch((err) => {
           setSending(false)
                console.log('My error: ', err);
                ApiResponseHandler(err.response, notificationCtx, navigate);
           })

    }
    return(

        <div>
            {showDash ? 
                <AdminDashboard />
            :
                <div className={'admin-login-container'}>
                    <div className='admin-login-card'>

                        <div className='logo-line'>
                            <STC.Logo.Bordered/>
                        </div>
                        <STC.Form onSubmit={handleSubmit}>
                            <STC.Form.FloatingLabel className='mb-2'>
                                <STC.Form.Control 
                                    id='floatingUserId'
                                    placeholder='Username or Email'
                                    value={userId}
                                    onChange={(e) => setUserId(e.target.value)}
                                    required
                                    disabled={sending}
                                    isInvalid={invalid}
                                />
                                <label htmlFor='floatingUserId' className='form-label'> Username or Email</label>
                            </STC.Form.FloatingLabel>

                            <STC.Form.FloatingLabel className='mb-2'>
                                <STC.Form.Control 
                                    id='floatingPassword'
                                    type='password'
                                    placeholder={'Password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    disabled={sending}
                                    isInvalid={invalid}
                                />
                                <label htmlFor='floatingPassword' className='form-label'> Password</label>
                            </STC.Form.FloatingLabel>
                            {invalid && <STC.Alert className='mt-1' variant='danger'>{errorMsg}</STC.Alert>}
                        
                            <div align={'right'} className="mt-2">
                                <STC.Button size="sm" disabled={sending} className={'cmn-button login-button'} type={'submit'} >Submit</STC.Button>
                            </div>

                        </STC.Form>
                    </div>
                </div>
            }
        </div>
    )
}